import React from 'react';
import { getLocationDisplayName } from './LocationName.utils';
import { AddressPropType } from '../../../foundation/types/address';
import './LocationName.css';
var defaultProps = {
  locationName: '',
  showCountry: false
};
export default function LocationName(_ref) {
  var locationName = _ref.locationName,
    address = _ref.address,
    showCountry = _ref.showCountry;
  var locationDisplayName = getLocationDisplayName(locationName, address, showCountry);
  if (!locationDisplayName) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "location-name-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "location-name"
  }, locationDisplayName));
}
LocationName.defaultProps = defaultProps;